import React, { useState } from "react";
import group_img from "../assets/images/image.png";
import logo from "../assets/images/logo.svg";
import app_store from "../assets/images/app_store.png";
import play_store from "../assets/images/play_store.png";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

const Home = () => {
  const [modalShow, setModalShow] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState({
    errorName: "",
    errorEmail: "",
    errorMessage: "",
  });
  const [loader, setLoader] = useState(false);

  const handleSubmit = () => {
    let isValid = true;
    const newErrors = { errorName: "", errorEmail: "", errorMessage: "" };

    // Name validation
    if (!name.trim()) {
      newErrors.errorName = "Name is required.";
      isValid = false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      newErrors.errorEmail = "Email is required.";
      isValid = false;
    } else if (!emailRegex.test(email)) {
      newErrors.errorEmail = "Invalid email format.";
      isValid = false;
    }

    // Message validation
    if (!message.trim()) {
      newErrors.errorMessage = "Message is required.";
      isValid = false;
    }

    setError(newErrors);

    if (isValid) {
      setLoader(true);

      // API url code
      fetch("", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          // toast.error("Failed to submit form. Please try again.");
          setLoader(false);
        })
        .finally(() => {
          toast.success("Form submitted successfully!");
          setModalShow(false);
          setLoader(false);
          setName("");
          setEmail("");
          setMessage("");
        });
    }
  };

  const handleClose = () => {
    setModalShow(false);
    setName("");
    setEmail("");
    setMessage("");
    setError({ errorName: "", errorEmail: "", errorMessage: "" });
  };
  return (
    <>
      <ToastContainer />
      <div className="site-wrapper d-flex justify-content-center align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center flex-column align-items-center gap-2">
              <img src={group_img} alt="..." style={{ width: "85%" }} />
            </div>
            <div className="col-md-6 p-0 align-self-center">
              <div className="d-flex justify-content-center align-items-center flex-column gap-3 text-center">
                <img src={logo} alt="..." style={{ width: "100px" }} />
                <div>
                  <p className="text-white para my-4">
                    Introducing your ultimate AI companion where you <br /> can
                    generate images, create content, and ask <br /> anything,
                    your reliable partner anytime.
                  </p>
                </div>
              </div>
              <div className="social mt-3 mb-3">
                <a href="#" alt="Google Play Store">
                  <img src={play_store} alt="..." width="100%" />
                </a>
              </div>
              <div className="social">
                <a href="#" alt="Apple Store">
                  <img src={app_store} alt="..." width="100%" />
                </a>
              </div>
            </div>

            {/* nav link */}
            <div
              className="nav d-flex justify-content-center align-items-center"
              style={{ marginTop: "25px" }}
            >
              <Link to="/privacy-policy" target="_blank" className="nav-link">
                Privacy Policy
              </Link>
              <Link to="/terms-condition" target="_blank" className="nav-link">
                Terms & Conditions
              </Link>
              <Link to="/eula" target="_blank" className="nav-link">
                Eula For Kedvik AI
              </Link>
              <Link to="/disclaimer" target="_blank" className="nav-link">
                Disclaimer for Kedvik AI
              </Link>

              <a className="nav-link" onClick={() => setModalShow(true)}>
                Contact Us
              </a>
            </div>

            {/* Contact Form Modal */}
            <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
              <ModalHeader>
                <h4 className="modal-title text-white">Contact Us</h4>
              </ModalHeader>
              <ModalBody className="modal-body">
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder="Enter your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control input"
                  />
                  <p>{error.errorName}</p>
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control input"
                  />
                  <p>{error.errorEmail}</p>
                </div>

                <div className="mb-3">
                  <textarea
                    rows="4"
                    placeholder="Write your Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="form-control input"
                  />
                  <p>{error.errorMessage}</p>
                </div>
              </ModalBody>
              <ModalFooter>
                <div style={{ display: "flex", gap: "10px" }} className="w-100">
                  <button
                    onClick={() => handleClose()}
                    className="fw-bold w-50 btn1 w-100 transition"
                  >
                    Cancel
                  </button>
                  <button
                    className="fw-bold w-50 btn2 w-100 transition"
                    onClick={() => handleSubmit()}
                  >
                    {loader ? <span className="loader"></span> : "Submit"}
                  </button>
                </div>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
